import styled from "styled-components";
import { Container, Row } from "react-bootstrap";

export const StyledActivityContainer = styled(Container)`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: start;
  @media screen and (max-width: 992px) {
    flex-direction: column;
    align-items: center;
  }
`;
export const LeftContent = styled.div`
  width: 75%;
  background: var(--white-color);
  border-radius: 6px;
  @media screen and (max-width: 992px) {
    width: 75%;
  }

  @media screen and (max-width: 786px) {
    width: 95%;
  }
  .ck.ck-editor {
    width: 100%;
    min-height: 130px;
    border-radius: 12px;
    background: var(--bg-color);
    border: 1px solid var(--blue-color-dark);
  }
  .ck.ck-editor__main > .ck-editor__editable {
    margin-top: 1.7rem;
    min-height: 100%;
    padding: 10px 10px !important;
    border-radius: 12px;
    background: var(--bg-color);
    border: none;
    @media screen and (max-width: 768px) {
      min-height: 155px;
    }
    p {
      margin-top: 5px;
      margin-bottom: 0px;
      @media screen and (max-width: 576px) {
        font-size: var(--font-size-xs);
      }
    }
  }
  .ck.ck-editor__top .ck-sticky-panel .ck-toolbar {
    display: none;
  }
  label {
    position: relative;
    z-index: 1;
    top: 35px;
    right: 10px;
    font-weight: 500;
    font-size: var(--font-size-sm);
    color: var(--tertiary-color);
    @media screen and (max-width: 576px) {
      font-size: var(--font-size-xs);
    }
  }
  .lab-report-title {
    font-size: var(--font-size-base);
  }
`;
export const RightContent = styled.div`
  width: 25%;
  min-height: 550px;
  border-left: 0.5px solid var(--text-color-dark);
  margin-left: 20px;
  padding-left: 20px;
  @media screen and (max-width: 992px) {
    width: 290px;
    margin-left: 0px;
    padding-left: 0px;
    border-left: none;
    min-height: auto;
  }
  @media screen and (max-width: 320px) {
    width: 250px;
  }
`;

export const StyledReportHeader = styled(Row)`
  display: grid;
  grid-template-columns: 50% [col-start] 25% [col-start];
  justify-content: end;
  align-items: center;

  .lab-report-title {
    max-width: 430px;
    font-size: var(--font-size-base);
    @media screen and (max-width: 576px) {
      font-weight: 500;
      background: transparent;
      width: auto;
      padding: 0px;
    }
  }
  .date-box {
    justify-self: end;
    width: 100px;
    height: 24px;
    background: #b0e1fb;
    border-radius: 6px;
    color: var(--text-color-dark);
    font-size: var(--font-size-xs);
    @media screen and (max-width: 425px) {
      width: 80px;
      padding: 0px;
    }
  }
`;

export const StyledUserInfo = styled.span`
  height: 130px;
  background: var(--button-color-labs);
  border: 2px solid var(--primary-color);
  border-radius: 12px;
  .profile-wrapper {
    position: relative;
    display: inline-block;
    min-width: 80px;
    height: 80px;
    border: 1px solid var(--primary-color);
    background: var(--white-color);
    box-shadow: 0px 6px 20px 5px rgba(62, 165, 219, 0.16);
    z-index: 2;
    &::before {
      content: "";
      position: absolute;
      display: inline-block;
      width: 70px;
      height: 70px;
      background: #e7e7e8;
      border-radius: 50%;
      top: 4px;
      left: 4px;
      z-index: -1;
    }
    img {
      object-fit: cover;
      object-position: center center;
      border-radius: 50%;
      width: 70px;
      height: 70px;
    }
  }
  .user-information {
    min-height: 80px;
    margin-right: 20px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
  }
  .user-name {
    font-weight: 500;
    font-size: var(--font-size-sm);
    color: var(--blue-color-dark);
  }
  .user-nid {
    font-size: var(--font-size-sm);
    color: var(--blue-color-dark);
  }
`;

export const UserHistoryInfo = styled.span`
  /* overflow: auto; */
  min-height: 150px;
  background: var(--white-color);
  border-radius: 6px;
  ul {
    list-style-type: none;
    li {
      border-radius: 6px;
      height: 30px;
    }
    li:nth-child(odd) {
      background: #b0e1fb;
    }
  }
`;
export const TitleBox = styled.span`
  width: 100%;
  font-size: var(--font-size-sm);
  color: var(--blue-color-dark);
  height: 40px;
  background: var(--button-color-labs);
  border-radius: 6px;
  position: relative;
  .edit-icon {
    cursor: pointer;
    position: absolute;
    top: 0.5rem;
    left: 1rem;
    @media screen and (max-width: 576px) {
      right: -3rem;
    }
  }
`;
export const ButtonRow = styled(Row)`
  width: auto;
  display: grid;
  gap: 20px;
  grid-template-columns: auto auto;
  justify-content: center;
  @media screen and (max-width: 768px) {
    grid-template-columns: auto;
    gap: 12px;
  }
  ${({ $teacherFeedBack }) => $teacherFeedBack && `width: 100%;display:block`}
`;
